import { createContext } from 'react';
import { PaginationProps } from './model';

export const PaginationContext = createContext<
	Pick<PaginationProps, 'numberOfPages' | 'selectedPage'> & { label: string }
	// eslint-disable-next-line @typescript-eslint/ban-ts-comment
	// @ts-ignore
>(null);

export default PaginationContext;
